<template><div><h1 id="concurrent-users" tabindex="-1"><a class="header-anchor" href="#concurrent-users"><span>Concurrent Users</span></a></h1>
<p>Concurrent Users — Listet die Anzahl angemeldeter Benutzer pro Tag auf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Statistik zeigt die Anzahl angemeldeter Benutzer pro Tag auf. Die Ausgabe beinhaltet eine grafische Übersicht mit der eingelogten Dauer nach Anzahl Benutzer, z.B während 200 Stunden war immer ein Benutzer angemeldet, während 50 Stunden waren immer 2 Benutzer angemeldet, usw.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Auswertungen → Monitoring → Concurrent Users</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Datum von/bis</dt>
<dd>Datumsbereich für die Auswertung.</dd>
<dt>Benutzer</dt>
<dd>Einschränkung nach Benutzer (Auswahlliste), standardmässig werden alle Benutzer berücksichtigt.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet nebst der grafischen Übersicht eine Liste mit den folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Datum</td>
<td>Datum</td>
</tr>
<tr>
<td>max. Anzahl</td>
<td>Die maximal Anzahl angemeldeter Benutzer (pro Tag)</td>
</tr>
<tr>
<td>angemeldete Benutzer</td>
<td>Benutzerkürzel der angemeldeten Benutzer</td>
</tr>
</tbody>
</table>
</div></template>


